query SearchBIMClass(
    $token: String!
) {
    searchBimClasses(
        term: $token
    ) {
        id

        data {
            name(language: "en") {
                text
            }
        }
    }
}
